import { SERVICE_TYPE } from '@/api/type/commonTypes';
import {
  GetPartnerServiceOptionsResponse,
  OPTION_TYPE,
} from '@/api/type/types';
import { useAppSelector } from '@/stores/hooks';
import { service } from '@/stores/slices/service-regist/serviceSlices';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';

interface BasicServiceOptionsProps {
  data: GetPartnerServiceOptionsResponse;
  basicData: OPTION_TYPE[];
  isEdited: boolean;
  serviceType: SERVICE_TYPE;
}
const BasicServiceOptions = ({
  data,
  basicData,
  isEdited,
  serviceType,
}: BasicServiceOptionsProps) => {
  const { allService, putPartnerServiceOptions: putData } = useAppSelector(
    (state) => state.service
  );
  const targetAllService = allService.find(
    (item) => item.serviceType === data.serviceType
  );
  const dispatch = useDispatch();

  const toggleOption = useCallback(
    (optionId: string) => () => {
      const currentPutData = putData?.[serviceType];

      if (!isEdited || !currentPutData) return;

      const exists = currentPutData.options.some((o) => o.id === optionId);

      let updatedOptions: OPTION_TYPE[];

      if (exists) {
        updatedOptions = currentPutData.options.filter(
          (o) => o.id !== optionId
        );
      } else {
        const newOpt = targetAllService?.options.find((o) => o.id === optionId);
        if (!newOpt) return;

        updatedOptions = [...currentPutData.options, newOpt];
      }

      dispatch(
        service.setPutPartnerServiceOptions({
          serviceType,
          data: {
            ...currentPutData,
            options: updatedOptions,
          },
        })
      );
    },
    [dispatch, isEdited, putData, serviceType, targetAllService?.options]
  );

  return (
    <OptionWrap>
      {targetAllService &&
        targetAllService.options.map((option) => (
          <Option
            key={option.id}
            data-selected={basicData.some((o) => o.id === option.id)}
            onClick={toggleOption(option.id)}
            data-disabled={!isEdited}
          >
            {option.name}
          </Option>
        ))}
    </OptionWrap>
  );
};

export default BasicServiceOptions;

const OptionWrap = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const Option = styled.button`
  padding: 0 29.5px;
  font-size: 14px;
  line-height: 140%;
  color: #777777;
  background: #e7e7e7;
  border-radius: 99px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: calc(100px - 58px);
  flex-shrink: 0;
  &[data-selected='true'] {
    background: #5b4be8;
    color: #fffbfb;
  }
  &[data-disabled='true'] {
    pointer-events: none;
  }
`;
